import React from 'react';
import { useParams } from 'react-router-dom';

import NATicketContainer from '@totem/components/unauthenticated/ticketing/details/naTicketContainer';
import NaTicketLayout from '@totem/components/unauthenticated/ticketing/details/naTicketLayout';
import NAPartyInvolvedContainer from '@totem/components/unauthenticated/ticketing/details/partyInvolved/naPartyInvolvedContainer';
import NaTaskContainer from '@totem/components/unauthenticated/ticketing/details/tasks/naTaskContainer';

const NATicketDetailsPage = () => {
  const { id } = useParams();

  return (
    <NAPartyInvolvedContainer token={id}>
      <NATicketContainer token={id}>
        <NaTaskContainer>
          <NaTicketLayout />
        </NaTaskContainer>
      </NATicketContainer>
    </NAPartyInvolvedContainer>
  );
};

export default NATicketDetailsPage;
